import type {
	getAllTransferRecordsInput,
	getTransferRecordsPlayerFacetsInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetAllTransferRecords: getAllTransferRecordsInput;
	useGetTransferRecordsFacets: getAllTransferRecordsInput;
	useGetTransferRecordsPlayerFacets: getTransferRecordsPlayerFacetsInput;
}

const TRANSFER_RECORDS_SERVICE_KEYS = createReactQueryKeys<Keys>(
	"transferRecords",
	[
		"useGetAllTransferRecords",
		"useGetTransferRecordsFacets",
		"useGetTransferRecordsPlayerFacets",
	],
);

export { TRANSFER_RECORDS_SERVICE_KEYS };
